var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{attrs:{"data-type":`city-${_vm.item.id}`,"to":{
    name: 'search-type',
    params: {
      type: _vm.$t('router.search_type.type.city'),
      value: _vm.item.slug,
      tab: _vm.$t('router.search_type.tab.tours'),
    },
  }}},[_c('span',{staticClass:"item-search-title"},[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),(_vm.hasDescription)?[_c('br'),_c('span',{staticClass:"item-search-description"},[_vm._v(_vm._s(_vm.item.description))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }